import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="relative w-full min-h-[80vh] md:min-h-[600px] flex items-center justify-center overflow-hidden bg-ink" data-id="element-98">
      {/* Parallax Background */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/pwiaJpW6rE6Y62bFJXFLpT/mick-haupt-SUYNZe93z1Y-unsplash.jpg")'
    }} data-id="element-99" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65" data-id="element-100" />
      {/* Center darkening for headline legibility */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)'
    }} data-id="element-101" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center py-12" data-id="element-102">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 uppercase tracking-wide max-w-4xl leading-tight [text-shadow:0_2px_12px_rgba(0,0,0,0.6)]" data-id="element-103">
          Authentic Cards. Signed Helmets. Buckeye Built.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-white mb-10 max-w-2xl [text-shadow:0_1px_8px_rgba(0,0,0,0.6)]" data-id="element-104">
          Graded cards, autographed memorabilia, and game-ready collectibles.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-105">
          <a href="#shop" className="w-full sm:w-auto bg-scarlet text-white font-bold uppercase tracking-wider px-8 py-4 rounded-lg hover:bg-scarlet/90 transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-106">
            Shop the Collection
          </a>
          <a href="#memorabilia" className="w-full sm:w-auto bg-transparent border-2 border-white text-white font-bold uppercase tracking-wider px-8 py-4 rounded-lg hover:bg-white hover:text-ink transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-107">
            New Arrivals
          </a>
        </motion.div>
      </div>
    </section>;
};